export default __webpack_public_path__ + "static/516-b4e4ae8c26ceca0486a7d7a5c8b13cdf.gif";